import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const feUrlGroupStatsApi = createAggrApiInstance(aggr.FrontendUrlGroupStatsApi)

export const getFeUrlGroupClicks = async (reqData: aggr.UrlGroupStatsClicksRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsClicks(reqData))
  return res
}

export const getFeUrlGroupAgeDistribution = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsAgedist(reqData))
  return res
}

export const getFeUrlGroupGenderDistribution = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsGenderdist(reqData))
  return res
}

export const getFeUrlGroupDeviceDistribution = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsDevicedist(reqData))
  return res
}

export const getFeUrlGroupRegionDistribution = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsRegiondist(reqData))
  return res
}

export const getFeUrlGroupSourceDistribution = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsSourcedist(reqData))
  return res
}

export const getFeUrlGroupInfo = async (reqData: aggr.UrlGroupStatsInfoRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsGroupinfo(reqData))
  return res
}

export const getFeUrlGroupStatsClicksSummary = async (reqData: aggr.UrlGroupStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlGroupStatsApi.urlgroupstatsClicksummary(reqData))
  return res
}
